import React from 'react'
import { GridItem } from '@which/seatbelt'

import type {
  LatestNews as LatestNewsType,
  NewsCard,
  SubVerticalHubPageQuery,
} from '../../../../generated/frontend'
import { FeaturedContent } from '../../../../shared/components/FeaturedContent'
import { HubPageJumplinks } from '../../components/HubPageJumplinks'
import { HubPageSections } from '../../components/HubPageSections'
import { SocialSharing } from '../../components/SocialSharing'
import { SubVerticalHeader } from '../../components/SubVerticalHeader'
import styles from '../../SubVerticalPage.module.scss'

export const getSubVerticalHubComponents = (data: SubVerticalHubPageQuery['subVerticalPage']) => {
  const {
    hubPageContent: { contentItems, mainFeaturedArticle, latestNewsTag, header },
    hubPageLatestNews,
    sharingData,
  } = data

  return {
    SubVerticalHeader: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <SubVerticalHeader title={header.title} intro={header.intro} variant="hubs" />
      </GridItem>
    ),
    JumpLinks: () => (
      <GridItem className={styles.hubpageJumplinks}>
        <HubPageJumplinks contentItems={contentItems} />
      </GridItem>
    ),
    LatestNews: () => (
      <>
        <GridItem className={styles.hubPageSharingTop} span={{ medium: 1, large: 1 }}>
          <SocialSharing data={sharingData} />
        </GridItem>
        <FeaturedContent
          withSideTrack={true}
          latestNewsTitle="Latest news"
          latestNews={hubPageLatestNews as LatestNewsType}
          mainFeaturedArticle={mainFeaturedArticle as NewsCard}
          latestNewsLink={{
            url: `/news/tag/${latestNewsTag.slug}`,
            text: `See all ${latestNewsTag.label} news`,
          }}
          lazyLoad={false}
        />
      </>
    ),
    HubPageContent: () => (
      <>
        <HubPageSections contentItems={contentItems} />
        <GridItem className={styles.hubPageSharingBottom}>
          <SocialSharing data={sharingData} />
        </GridItem>
      </>
    ),
  }
}
